import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { N700 } from '@atlaskit/theme/colors';

import { AccountCreation } from '@/components/signup/account-creation/account-creation';
import { useUserContext } from '@/components/user-context/user-context-provider';

import { EmbeddedSignupFormWrapper } from './components/embedded-signup-form-wrapper';
import { ExistingProductText } from './components/existing-product-text';

export const DefaultEmbeddedSignupForm = () => {
	const { product } = useUserContext();
	return (
		<EmbeddedSignupFormWrapper>
			<div css={containerStyle} data-testid="signup-form">
				<h1>
					<FormattedMessage
						id="BxpUiSignup.EmbeddedSignupForm.header"
						defaultMessage="Get started with {product}"
						values={{ product: product?.name }}
					/>
				</h1>
				<h2>
					<FormattedMessage
						id="BxpUiSignup.EmbeddedSignupForm.subheader.1"
						defaultMessage="It's free for up to 10 users — no credit card needed."
					/>
				</h2>
				<AccountCreation Login={null} />
				<ExistingProductText />
			</div>
		</EmbeddedSignupFormWrapper>
	);
};

const containerStyle = css({
	alignItems: 'stretch',
	color: N700,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
});
